module.exports = __webpack_public_path__ + "assets/img/Goal.webp?e94808a2d8b3c763486ab058f48183bb";